/**
 * https://logaretm.github.io/vee-validate/guide/localization.html#using-the-default-i18n
 * https://logaretm.github.io/vee-validate/guide/localization.html#using-other-i18n-libraries
 */

import {localize} from 'vee-validate';

localize({
	en: {
		fields: {
			'tos': {
				'required': 'You must agree to the Terms of Service'
			},
			'events-selected-count': {
				'required': 'You must attend to at least one event'
			},
			'first_name': {
				'required': 'First name can not be empty'
			},
			'last_name': {
				'required': 'Last name can not be empty'
			},
			'salutation': {
				'required': 'Salutation can not be empty'
			},
			'email': {
				'required': 'Email can not be empty'
			},
			'country': {
				'required': 'Please select a country'
			},
			'city': {
				'required': 'City can not be empty'
			}
		},
		messages: {
			required: 'This field is required',
			email: 'You must enter a valid email address',
		}
	}
});
